import { connect } from 'react-redux';

import PardotView from './PardotView.jsx';
import { getIntegrationForType, fetchIntegrations } from 'src/legacy/redux/actions/integrations.jsx';
import { authenticateAccount } from 'src/legacy/redux/actions/integrations/pardot.jsx';  
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from 'src/legacy/redux/actions/adoption';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'pardot');
  return {
    integration: integration,
    integrations: state.legacyRootReducer.settings.integrations,
    deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
    user: _.get(state, 'users.me',""),
    integrationsLoading: _.get(state.legacyRootReducer.settings.integrations, 'activated.loading' ,false)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateAccount: (code) => {
      return dispatch(authenticateAccount(code));
    },

    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName))
    }
    
  }
}

const PardotPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(PardotView);

export default withUseHooks(PardotPage);
